import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { recipesDetail, Limpiarfiltro } from '../actions'
import {Link} from "react-router-dom"
import s from '../componentsStlyes/RecipesDetail.module.css'

export default function RecipesDetail(props){
    console.log('Entré a RecipesDetail')
        let id= props.match.params.id
        const dispatch = useDispatch()
        //console.log( props)
        useEffect(()=>{
            dispatch(Limpiarfiltro())
            dispatch(recipesDetail(id))
        },[dispatch])
        
        
        const recipe = useSelector(state=>state.recipesDetail)


        
    return(
        <div className={s.fondo}>
            {
                recipe.length > 0? 
                <div className={s.subFondo}>
                    <a  href="/Cards" className={s.volver} >Return</a>
                    <div className={s.divTitle}>
                        <h4 className={s.titulo}>{recipe[0].title}</h4>
                    </div>
                    <div >
                        <img className={s.imagen} src={recipe[0].image} alt='No hay imagen'/>
                    </div>
                    <div className={s.divs}>
                        <h4>Recipe</h4>
                        <h5>{recipe[0].summary}</h5>
                    </div>
                    <div className={s.divDietas}>
                        <h4>Diets</h4>
                        <h5> {recipe[0].diets}</h5>
                    </div>
                    <div className={s.divs}>
                        <div className={s.healthScore}>
                            <h4>HealthScore</h4>
                            <h5> {recipe[0].healthScore}</h5>
                        </div>
                    </div>

                </div>:'Error'  
            }
        </div>
    )
}